<template>
    <div>
        <tabs
            :items="sections"
            :active-item="section"
            class="mb-3"
            @item-change="section = $event"
        />

        <div v-if="section.value === 'general'">
            <div class="form-group col-12">
                <b-form-checkbox v-model="item.isVisible" switch>
                    Is Visible
                </b-form-checkbox>
            </div>

            <form-input
                v-model="item.name"
                label="Name"
                :error-message="getError('name')"
                placeholder="Name"
                @blur="$emit('on-name-change', item.name)"
            />
            <form-input
                v-model="item.description"
                label="Description"
                :error-message="getError('description')"
                placeholder="Description"
                component-type="textarea"
            />
            <form-input
                v-model="item.termsLink"
                label="Terms link"
                :error-message="getError('termsLink')"
                placeholder="Terms link"
            />
            <form-input
                v-model="item.termsDescription"
                label="Terms description"
                :error-message="getError('termsDescription')"
                placeholder="Terms description"
                component-type="textarea"
            />
        </div>

        <div v-if="section.value === 'articles'">
            <articles-chooser
                :value="item.articles"
                :filters="articleFilters"
                @on-articles-change="onArticlesChange"
            />
        </div>
    </div>
</template>

<script>
import Tabs from '@/components/elements/Tabs';
import { ArticleStatus } from '@/enums/articles';
import BaseForm from '@/components/elements/BaseForm';
import ArticlesChooser from '@/components/elements/ArticlesChooser';

export default {
    components: {
        Tabs,
        ArticlesChooser
    },

    extends: BaseForm,

    data() {
        return {
            section: { value: 'general' }
        };
    },

    computed: {
        sections() {
            return [
                {
                    value: 'general',
                    text: 'General',
                    hasError: this.validation.item.$error
                },
                {
                    value: 'articles',
                    text: 'Articles'
                }
            ];
        },

        articleFilters() {
            const language = this.value.language;

            return {
                'language.code': {
                    value: language?.code || null,
                    type: 'eq'
                },
                status: { value: ArticleStatus.PUBLISHED, type: 'eq' }
            };
        }
    },

    watch: {
        'value.language'() {
            this.item.language = this.value.language;
        }
    },

    methods: {
        onArticlesChange(articles) {
            this.item.articles = articles;
        }
    }
};
</script>
